import React, { useContext } from 'react';
import { Context } from '../../../context/AppContext';
import Share from '../Cards/Card/Share';
import './styles.css';

const Title = ({ subTitle, total, title, suburb, category, url, state }) => {
  const {
    media: { device, desktop },
  } = useContext(Context);

  return (
    <div className={`Listview__Title__root Listview__Title__root--${device}`}>
      <div className="Listview__Title__left">
        <div className="Listview__Title__wrapper">
          <h1>{title}</h1>
          {desktop && (
            <Share
              url={url}
              name={`${category} in ${suburb}`}
              suburb={suburb}
              state={state}
              text="Share list"
            />
          )}
        </div>
        {!!total && (
          <h2>
            {subTitle ? `Need ${subTitle.trim()}?` : ''} These{' '}
            <span className="Listview__Title__count">{total}</span> results are
            waiting for your call. Here are our top{' '}
            <span className="Listview__Title__suburbCategory">
              {suburb} {category}
            </span>{' '}
            with reviews & ratings.
          </h2>
        )}
      </div>
    </div>
  );
};

export default Title;
